export default {"src":"/_next/static/media/configure-company-invite.a78cd11c.svg","height":143,"width":211};